import { api } from "@/lib/api";
import { toast } from "sonner";

const FAN_KEY = "titan_fan_id_v1";

export function getFanId() {
  let id = localStorage.getItem(FAN_KEY);
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `fan-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(FAN_KEY, id);
  }
  return id;
}

export function toastAward(award) {
  if (!award) return;
  if (award.xp_gained > 0) {
    toast.success(`+${award.xp_gained} XP`, {
      description: `Level ${award.level} · ${award.streak}-day streak`,
    });
  }
  (award.new_achievements || []).forEach((a) => {
    toast(`Achievement unlocked — ${a.name}`, { description: a.desc });
  });
  window.dispatchEvent(new Event("fz:refresh"));
}

export const fz = {
  hello: () => api.post("/fanzone/hello", { fan_id: getFanId() }),
  setName: (name) => api.post("/fanzone/name", { fan_id: getFanId(), name }),
  leaderboard: (period) => api.get("/fanzone/leaderboard", { params: { period, fan_id: getFanId() } }),
  achievements: () => api.get("/fanzone/achievements"),
  grid: {
    daily: () => api.get("/fanzone/grid/daily", { params: { fan_id: getFanId() } }),
    search: (q) => api.get("/fanzone/grid/search", { params: { q } }),
    guess: (row, col, guess) => api.post("/fanzone/grid/guess", { fan_id: getFanId(), row, col, guess }),
  },
  blur: {
    daily: () => api.get("/fanzone/blur/daily", { params: { fan_id: getFanId() } }),
    guess: (guess) => api.post("/fanzone/blur/guess", { fan_id: getFanId(), guess }),
  },
  jersey: {
    daily: () => api.get("/fanzone/jersey/daily", { params: { fan_id: getFanId() } }),
    guess: (guess) => api.post("/fanzone/jersey/guess", { fan_id: getFanId(), guess }),
  },
  history: {
    today: () => api.get("/fanzone/history/today", { params: { fan_id: getFanId() } }),
    guess: (year) => api.post("/fanzone/history/guess", { fan_id: getFanId(), year }),
  },
  claim: (game, result) => api.post("/fanzone/claim", { fan_id: getFanId(), game, result }),
  roster53: {
    pool: () => api.get("/fanzone/roster53/pool", { params: { fan_id: getFanId() } }),
    submit: (players) => api.post("/fanzone/roster53/submit", { fan_id: getFanId(), players }),
    consensus: () => api.get("/fanzone/roster53/consensus"),
  },
  predict: {
    games: () => api.get("/fanzone/predict/games", { params: { fan_id: getFanId() } }),
    submit: (picks) => api.post("/fanzone/predict/submit", { fan_id: getFanId(), picks }),
    leaderboard: () => api.get("/fanzone/predict/leaderboard", { params: { fan_id: getFanId() } }),
  },
  stock: {
    market: () => api.get("/fanzone/stock/market", { params: { fan_id: getFanId() } }),
    trade: (stock_id, action, qty) => api.post("/fanzone/stock/trade", { fan_id: getFanId(), stock_id, action, qty }),
    leaderboard: () => api.get("/fanzone/stock/leaderboard"),
  },
  capgm: {
    pool: () => api.get("/fanzone/capgm/pool", { params: { fan_id: getFanId() } }),
    submit: (squad) => api.post("/fanzone/capgm/submit", { fan_id: getFanId(), squad }),
  },
  trade: {
    teams: () => api.get("/fanzone/trade/teams"),
    roster: (team_id) => api.get("/fanzone/trade/roster", { params: { team_id } }),
    evaluate: (payload) => api.post("/fanzone/trade/evaluate", { fan_id: getFanId(), ...payload }),
    recent: () => api.get("/fanzone/trade/recent"),
  },
};

const CLAIM_KEY = "titan_fz_claimed_v1";

export async function claimOnce(game, dateKey, result) {
  try {
    const store = JSON.parse(localStorage.getItem(CLAIM_KEY) || "{}");
    if (store[game] === dateKey) return;
    const { data } = await fz.claim(game, result);
    store[game] = dateKey;
    localStorage.setItem(CLAIM_KEY, JSON.stringify(store));
    if (!data.already_claimed) toastAward(data.award);
  } catch {
    /* silent */
  }
}
